"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Localization_1 = require("../utils/Localization");
exports.local = new Localization_1.Internationalization({
    localeJson: require('./locales/en_US.json'),
    defaultLocale: 'en-US',
    pseudoLocalizationEnabled: false,
});
